'use strict';
import * as $j_app$002edata$002etypes$005fchat$0024package$0024$002dChat$002dExpires$002dAt$0024 from "./app.data.types_chat$package$-Chat-Expires-At$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8() {
}
export { $c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 as $c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 };
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 as $h_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 };
$h_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype = $c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy6 = $j_app$002edata$002etypes$005fchat$0024package$0024$002dChat$002dExpires$002dAt$0024.$m_Lapp_data_types\uff3fchat$package$ChatExpiresAt$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy6, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8, "app.api.DrugRequestPharmacyState$ChatStarted$$anon$8", ({
  Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 as $d_Lapp_api_DrugRequestPharmacyState$ChatStarted$$anon$8 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Chat-Started$$anon$8.js.map
